export default __webpack_public_path__ + "static/media/Risk.388c57ce.svg";